import { mastercardAdapter as mastercard } from './mastercard'

export const sdkAdapters = {
  mastercard
}
